import moment from "moment-timezone";

export const GIFT_STATUS = {
  NOT_ACTIVATED: 1,
  PENDING_SEND: 2,
  PENDING_PROCESS: 3,
  SENT: 4,
  CANCELLED: 5,
};

export const STATUS_LABELS = {
  [GIFT_STATUS.NOT_ACTIVATED]: "Chưa kích hoạt",
  [GIFT_STATUS.PENDING_SEND]: "Cần gửi",
  [GIFT_STATUS.SENT]: "Đã gửi",
  [GIFT_STATUS.PENDING_PROCESS]: "Cần xử lý",
  [GIFT_STATUS.CANCELLED]: "Đã hủy",
};

export const GIFT_ACTION = {
  SEND: "send",
  RESET: "reset",
  PROCESS: "process",
  CANCEL: "cancel",
};

export const STATUS_ACTION_MAP = {
  [GIFT_STATUS.NOT_ACTIVATED]: [],

  [GIFT_STATUS.PENDING_SEND]: [
    GIFT_ACTION.SEND,
    GIFT_ACTION.CANCEL,
  ],

  [GIFT_STATUS.SENT]: [
    GIFT_ACTION.RESET,
  ],

  [GIFT_STATUS.PENDING_PROCESS]: [
    GIFT_ACTION.PROCESS,
    GIFT_ACTION.CANCEL,
  ],

  [GIFT_STATUS.CANCELLED]: [],
};

export const ACTION_META = {
  [GIFT_ACTION.SEND]: {
    label: "Gửi quà",
    title: "Gửi quà",
    icon: "el-icon-present",
    className: "btn-outline-success",
    targetStatus: GIFT_STATUS.SENT,
    requireReason: false,
  },
  [GIFT_ACTION.RESET]: {
    label: "Reset quà",
    title: "Reset quà",
    icon: "el-icon-refresh",
    className: "btn-outline-primary",
    targetStatus: GIFT_STATUS.PENDING_SEND,
    requireReason: true,
  },
  [GIFT_ACTION.PROCESS]: {
    label: "Duyệt gửi quà",
    title: "Duyệt gửi quà",
    icon: "el-icon-check",
    className: "btn-outline-primary",
    targetStatus: GIFT_STATUS.PENDING_SEND,
    requireReason: true,
  },
  [GIFT_ACTION.CANCEL]: {
    label: "Hủy quà",
    title: "Hủy quà",
    icon: "el-icon-close",
    className: "btn-outline-danger",
    targetStatus: GIFT_STATUS.CANCELLED,
    requireReason: true,
  },
};

function formatDate(value) {
  if (!value) return "";
  const date = moment(value);
  if (!date.isValid()) return value;

  return date.format("DD-MM-YYYY HH:mm:ss");
}

function getStatusCode(status) {
  if (status === null || status === undefined || status === "") return null;
  const code = Number(status);

  return Number.isNaN(code) ? null : code;
}

export class ManageGiftProgramModel {
  constructor(item = {}) {
    const statusCode = getStatusCode(item.logistic_user_gift_status);

    this.raw = item;
    this.id = item.id;
    this.giftCode = item.gift_id;
    this.giftName = item.name || "";
    this.customerId = item.user_id;
    this.customerName = item.user_name
    this.customerPhone = item.phone
    this.contractCode = item.contract_id;
    this.statusCode = statusCode;
    this.status = STATUS_LABELS[statusCode] || "";
    this.createdAt = formatDate(item.created_at);
    this.followAt = formatDate(item.timeline);
    this.address = item.address || "";
    this.actions = STATUS_ACTION_MAP[statusCode] || [];
    this.actionItems = this.actions.map(action => ({
      action,
      ...ACTION_META[action],
    })).filter(item => item.label);
  }
}

export const giftProgramStatusOptions = Object.entries(STATUS_LABELS).map(([value, label]) => ({
  label,
  value: Number(value),
}));
